module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec03_pc_e3690543e02b5ab770e31973f60081f9.jpg";